import { Stack } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpFromBracket } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"

import { AiMenuButton } from "./ai/AiMenuButton"

const useStyles = makeStyles()((theme) => ({
    // Explicit height because the default button size grows past the 44px header row.
    headerButton: {
        "&.MuiButton-root": {
            height: "2.75rem",
        },
    },
    publishButton: {
        "&.MuiButton-root": {
            height: "2.75rem",
            backgroundColor: theme.palette.tailwind.green[600],
            "&:hover": {
                backgroundColor: theme.palette.tailwind.green[700],
            },
        },
        "& .MuiButton-startIcon svg": {
            fontSize: "1rem",
        },
    },
}))

type Props = Readonly<{
    onQuickGenerate: () => void
    onCustomize: () => void
    onCustomerView: () => void
    onPublish: () => void
}>

/** The page-title action row: AI menu, customer view and publish. */
export function WeekMenuHeaderActions({ onQuickGenerate, onCustomize, onCustomerView, onPublish }: Props) {
    const { classes } = useStyles()

    return (
        <Stack direction="row" alignItems="center" spacing=".75rem">
            <AiMenuButton onQuickGenerate={onQuickGenerate} onCustomize={onCustomize} />
            <LocalizedStrict id="merchant-week-menu-customer-view-button">
                <StandardButton
                    fullWidth={false}
                    variant="outlined"
                    color="black"
                    className={classes.headerButton}
                    onClick={onCustomerView}
                >
                    Customer View
                </StandardButton>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-week-menu-publish-button">
                <StandardButton
                    fullWidth={false}
                    className={classes.publishButton}
                    startIcon={<FontAwesomeIcon icon={faArrowUpFromBracket} />}
                    onClick={onPublish}
                >
                    Publish ready days
                </StandardButton>
            </LocalizedStrict>
        </Stack>
    )
}
